module.exports = __webpack_public_path__ + "img/arrow-right.6c38363f.svg";